import React, { useState } from 'react';

// 아이콘 라이브러리를 쓰지 않으므로 inline SVG. 버튼이 aria-label로 이름을
// 가지므로 아이콘 자체는 스크린 리더에서 숨긴다.
function PasswordVisibilityIcon({ visible }) {
    const shared = {
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 1.75,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        'aria-hidden': true,
        focusable: 'false',
    };

    if (visible) {
        return (
            <svg {...shared}>
                <path d="M10.7 5.2A11 11 0 0 1 12 5c6.4 0 10 7 10 7a18.8 18.8 0 0 1-3.2 4.2" />
                <path d="M6.6 6.6A18.6 18.6 0 0 0 2 12s3.6 7 10 7a10.8 10.8 0 0 0 4.3-.9" />
                <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
                <line x1="3" y1="3" x2="21" y2="21" />
            </svg>
        );
    }

    return (
        <svg {...shared}>
            <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    );
}

// 비밀번호 입력창 + 보이기/숨기기 토글. 표시 상태는 필드마다 따로 들고 있어서
// 한 화면에 여러 개가 있어도 서로 영향을 주지 않는다. className은 쓰는 쪽의
// 입력창 스타일을 그대로 받고, wrapperClassName은 감싸는 div의 바깥 여백처럼
// 입력창이 아니라 자리(layout)에 붙어야 하는 스타일을 받는다.
export default function PasswordInput({
    className = '',
    wrapperClassName = '',
    ...inputProps
}) {
    const [visible, setVisible] = useState(false);

    return (
        <div className={`auth-password-field ${wrapperClassName}`.trim()}>
            <input
                {...inputProps}
                type={visible ? 'text' : 'password'}
                className={`${className} auth-input-with-toggle`.trim()}
            />
            <button
                type="button"
                className="auth-password-toggle"
                onClick={() => setVisible((prev) => !prev)}
                aria-label={visible ? 'Hide password' : 'Show password'}
                aria-pressed={visible}
            >
                <PasswordVisibilityIcon visible={visible} />
            </button>
        </div>
    );
}
